export { v1PortImplementation } from 'modules/Integrations/communication/external/v1/integrations.api.v1'
